"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledResponsiveDialog = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
const StyledResponsiveDialog = exports.StyledResponsiveDialog = (0, _mui.styled)(_presentationComponents.ResponsiveDialog)(({
  theme
}) => ({
  [`.${_presentationComponents.responsiveDialogClasses.drawerTitleContainer}`]: {
    padding: theme.spacing(0, 4, 3)
  },
  [`.${_presentationComponents.responsiveDialogClasses.dialogTitle}`]: {
    padding: theme.spacing(6, 3, 0),
    h4: {
      margin: 0
    }
  },
  [`.${_presentationComponents.responsiveDialogClasses.content}`]: {
    height: '100%',
    margin: 0,
    padding: 0
  },
  [`.${_components.dialogClasses.content}`]: {
    paddingLeft: 0,
    paddingRight: 0
  },
  [`.${_presentationComponents.responsiveDialogClasses.dialogContent}`]: {
    margin: 0
  }
}));
//# sourceMappingURL=styles.js.map